<div id="driver-wizard"
     class="row ">
     <div class="overlay"
          *ngIf="isSaving">
          <h1 [innerHtml]="'Loading' | translator:'base'">Saving ...</h1>
          <img alt="Saving" />
     </div>
     <div class="d-flex justify-content-between align-items-center"
          id="page-title">
          <h1 [innerHtml]="'RecordMonitoringSuccessfully' | translator: 'base'">
               Successfully Subscribed
          </h1>
     </div>
     <div class="col-lg-8">
          <div class="card shadow-sm rounded-0 border-0">
               <div class="card-body">
                    <app-complete-bar [step]="5"
                                      [totalSteps]="5"></app-complete-bar>
                    <h2 [innerHtml]="'subscribed_success1' | translator: 'base'">
                         You have successfully enrolled in PSP Driver Record Monitoring.
                    </h2>
                    <p class="text"
                       [innerHtml]="'subscribed_receive' | translator: 'base'">
                         PSP records contain your five-year crash violation data and three-year roadside
                         inspection history. You will be notified via email if there is an update to your PSP record,
                         including:
                    </p>
                    <ul>
                         <li [innerHtml]="'subscribed_li1' | translator: 'base'">
                              New crash violation and or inspection data.</li>
                         <li [innerHtml]="'subscribed_li2' | translator: 'base'">
                              New crash violation and or inspection data.</li>
                    </ul>

                    <p class="text"
                       [innerHtml]="'subscribed_explaining1' | translator: 'base'">
                         To request your latest PSP record, you will need to create your PSP Login.gov account
                         and request a record from the driver dashboard. The price per report is $10.
                    </p>

                    <p class="text"
                       [innerHtml]="'subscribed_explaining2' | translator: 'base'">
                         If you have already requested your record you can view and or download it from the driver
                         dashboard for 5 days or 120 hours.
                    </p>

                    <div class="text">
                         <button (click)="finish()"
                                 class="btn btn-primary btn-strong"
                                 name="finish"
                                 id="finish"
                                 [innerHtml]="'Finish' | translator: 'base'"
                                 [title]="'Finish' | translator: 'base'">
                              Finish
                         </button>
                    </div>
               </div>
          </div>
     </div>
     <app-progress-wizard *ngIf="wizard"
                          [wizardObj]="wizard"
                          [activeStep]="5"
                          pageType="driver"
                          class="col-lg-4 sidebar d-none d-lg-block">
     </app-progress-wizard>
</div>